import { styleConstants } from '@paywithextend/components'
import {
  base_colorAction,
  base_colorSurface,
  notification_colorAlert,
  tag_colorTagDefaultBackground,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import { css } from 'styled-components'

// Count callout that replaces the old progress meter. A left accent bar
// (blue within-limit, red over-limit), a badge, a large number, and a label.
export default css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 8px;
  background: ${base_colorSurface};
  border-left: 4px solid ${base_colorAction};

  &.over-limit {
    border-left-color: ${notification_colorAlert};
  }

  .DowngradeCardCount-badge {
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    gap: 4px;
    height: 20px;
    font-family: ${styleConstants.fontFamilies.medium};
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    letter-spacing: 0;
  }

  .DowngradeCardCount-badge--ok {
    padding: 0 4px;
    border-radius: 4px;
    background: ${tag_colorTagDefaultBackground};
    color: ${text_colorTextPrimary};
  }
  .DowngradeCardCount-badge--ok svg {
    width: 14px;
    height: 14px;
  }
  .DowngradeCardCount-badge--ok svg path {
    stroke: ${text_colorTextPrimary};
  }

  .DowngradeCardCount-badge--over {
    color: ${notification_colorAlert};
    text-transform: uppercase;
  }
  .DowngradeCardCount-badge--over svg {
    width: 14px;
    height: 14px;
  }

  .DowngradeCardCount-count-row {
    display: flex;
    align-items: baseline;
    gap: 8px;
  }

  /* text-heading-h1: 40 / 48 / 500 */
  .DowngradeCardCount-count {
    font-family: ${styleConstants.fontFamilies.medium};
    font-size: 40px;
    line-height: 48px;
    font-weight: 500;
    letter-spacing: 0;
    color: ${text_colorTextPrimary};
    font-variant-numeric: tabular-nums;
  }
  &.over-limit .DowngradeCardCount-count {
    color: ${notification_colorAlert};
  }

  /* text-paragraph-support-text-medium: 14 / 18 / 500, text-primary — per
     EX-39820 Figma, both the over-limit and within-limit copy. */
  .DowngradeCardCount-label {
    font-family: ${styleConstants.fontFamilies.medium};
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    letter-spacing: 0;
    color: ${text_colorTextPrimary};
  }
`
